export const clearEmptyContacts = restaurant => {
  restaurant.contact_person = restaurant.contact_person.filter(contact => (
    contact.first_name
    || contact.note
    || contact.phone
    || contact.position
    || contact.is_receive_messages
  ))
  return restaurant
}